<template>
	<div class="ModuleTop">
		<div class="ModuleTopBody">
			<div class="ModuleTopBodyLogo">
				<div class="ModuleTopBodyLogoBody" @click="onToHome()">
					<img :src="LogoData" width="100%"/>
				</div>
			</div>
			<div class="ModuleTopBodySearch">
				<div class="ModuleTopBodySearchBody">
					<div class="ModuleTopBodySearchBodyInput">
  						<el-input v-model="SearchKey" placeholder="输入关键词搜索" @keydown="onSearchKeyKeydown" clearable @clear="onSearchKeyClear"/>
					</div>
					<div class="ModuleTopBodySearchBodySubmitBtn" title="点击搜索" @click="onSearchClick()">
						<el-icon><Search /></el-icon>
					</div>
				</div>
			</div>
			<div class="ModuleTopBodyNav">
				<div class="ModuleTopBodyNavBody">
					<div class="ModuleTopBodyNavBodyItem" v-for="(Item,Index) in NavData" :key="Index" @click="NavClick(Item)">
						<div class="ModuleTopBodyNavBodyItemBackground" 
							:style="IsSelectNav(Item.Path)?'height: 100%;':'height: 0%;'"
						></div>
						<div class="ModuleTopBodyNavBodyItemBody" 
							:style="IsSelectNav(Item.Path)?'color: #fff;':'color: #333;'"
						>
							{{Item.Title}}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	@import "./index.scss";
</style>
<script>
  import index from "./index-Js";
  export default index;
</script>
